var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContactForm',{attrs:{"item":{
    containerFullWidth: true,
    watchRef: this.item.product.manufacturer_sku,
    subjectListType: 'contact',
    defaultSubject: '10'
  }}},[_c('ProductMiniPreview',{attrs:{"item":this.item,"picture":this.picture}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }